export default __webpack_public_path__ + "static/media/yellowArrowDownLow.addde4c9.svg";